import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { FlexBoxCol } from '@r1-frontend/ui-react/components/layouts/flexBoxGrid';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/features/domru-bonus/styled';

export const CardWrapper = styled(FlexBoxCol)`
    width: 433px;
    padding: 32px 143px 32px 40px;
    border-radius: 16px;
    color: ${COLORS.white};
    background: radial-gradient(63.45% 90.07% at 28.3% 105.36%, #ED3D3D 0%, rgba(237, 61, 61, 0) 100%),
                linear-gradient(105.23deg, #B9CF31 15.62%, #FA00FF 106.65%);

    @media (max-width: ${breakPoints.laptop}) {
        max-width: 340px;
        padding: 24px 20px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        flex-direction: column;
        max-width: unset;
        width: 100%;
        margin-bottom: 12px;
    }

    &:not(:last-child) {
        margin-right: 32px;

        @media (max-width: ${breakPoints.laptop}) {
            margin-right: 20px;
        }

        @media (max-width: ${breakPoints.mobile}) {
            margin-right: 0;
            margin-bottom: 12px;
        }
    }
`;

export const CardTitle = styled.p`
    ${FONTS.L};
    margin-bottom: 16px;
`;

export const CardText = styled.p`
    ${FONTS.XS};

    @media (max-width: ${breakPoints.mobile}) {
        max-width: 250px;
    }
`;
